(function () {
  var nav = document.querySelector('[data-redesign-nav]');
  if (!nav) return;

  var pill = nav.querySelector('[data-nav-pill]');
  if (!pill) return;

  var header = document.querySelector('header[data-theme]');
  var items = Array.from(nav.querySelectorAll('[data-nav-item]'));
  var activeItem = nav.querySelector('[data-highlighted]');

  var PILL_RADIUS = '9999px';
  var LOGO_RADIUS = '0 1.3rem 1.3rem 1.3rem';

  function radiusFor(el) {
    return el.hasAttribute('data-nav-logo') ? LOGO_RADIUS : PILL_RADIUS;
  }

  function setPillRect(el) {
    var navRect = nav.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    // Pill's CSS top:0/left:0 is relative to nav's PADDING box (inside the
    // border), but getBoundingClientRect returns OUTER coords. Subtract the
    // border width (clientTop / clientLeft) so the pill aligns with items.
    pill.style.width = elRect.width + 'px';
    pill.style.height = elRect.height + 'px';
    pill.style.borderRadius = radiusFor(el);
    pill.style.transform =
      'translate(' +
      (elRect.left - navRect.left - nav.clientLeft) +
      'px, ' +
      (elRect.top - navRect.top - nav.clientTop) +
      'px)';
  }

  // Pill's CSS transition is 300ms. Track when a movePillTo started so async
  // re-sync handlers can avoid cancelling an animation that is still running.
  var TRANSITION_MS = 300;
  var lastMoveAt = 0;

  function movePillTo(el) {
    if (!el) {
      pill.style.opacity = '0';
      return;
    }
    pill.style.opacity = '1';
    setPillRect(el);
    lastMoveAt = Date.now();
  }

  function setHighlight(el) {
    items.forEach(function (item) {
      delete item.dataset.highlighted;
    });
    if (el) el.dataset.highlighted = '';
  }

  // Snap to a new position without animating transform/size — used to re-sync
  // after layout-shifting events (font swap, image decode). Doesn't touch
  // opacity so it can run mid-fade without flicker.
  function jumpPillTo(el) {
    if (!el) return;
    pill.style.transition = 'none';
    setPillRect(el);
    pill.offsetHeight; // eslint-disable-line no-unused-expressions
    pill.style.transition = '';
  }

  // Initial reveal — snap to position while hidden, then fade opacity in
  // using the element's existing CSS transition. Used for the first pill
  // appearance so it doesn't slide in from a stale (or empty) position.
  function revealPillAt(el) {
    if (!el) return;
    pill.style.transition = 'none';
    pill.style.opacity = '0';
    setPillRect(el);
    pill.offsetHeight; // eslint-disable-line no-unused-expressions
    pill.style.transition = '';
    pill.style.opacity = '1';
    lastMoveAt = Date.now();
  }

  // If the pill is currently hidden, spawn it at `el` (snap + fade in) so it
  // doesn't appear to fly across the nav from an old/empty position. If it's
  // already visible, slide it (CSS transition) — that's the regular hover feel.
  function targetPill(el) {
    if (!el) return;
    var current = pill.style.opacity;
    if (current === '' || current === '0') {
      revealPillAt(el);
    } else {
      movePillTo(el);
    }
  }

  function currentTarget() {
    return nav.querySelector('[data-highlighted]') || activeItem;
  }

  // Re-sync handlers (font-ready, img-load, ResizeObserver) call jumpPillTo,
  // which kills the in-flight transition. Suppress them while the user is
  // actively interacting with the nav, AND while a movePillTo animation is
  // still running — otherwise a layout shift triggered by removing
  // [data-highlighted] (the logo's <img> swapping back on mouseleave) fires
  // the observer just after the return animation starts and snaps the pill.
  function suppressJump() {
    if (nav.matches(':hover') || nav.contains(document.activeElement)) return true;
    if (Date.now() - lastMoveAt < TRANSITION_MS + 50) return true;
    return false;
  }

  // While the nav container is mid-morph (collapsed → expanded width transition),
  // defer pill positioning until the width transition ends. With shrink-0 on
  // the items wrapper this is mostly belt-and-suspenders — items hold their
  // natural sizes through the morph — but it also avoids any first-hover that
  // happens to coincide with the morph from triggering a slide before the
  // pill has been revealed at the right rest position.
  var morphInProgress = false;
  var pendingHoverItem = null;

  function targetPillWhenSettled(item) {
    if (!morphInProgress) {
      targetPill(item);
      return;
    }
    pendingHoverItem = item;
  }

  if (header) {
    var morphObserver = new MutationObserver(function () {
      if (header.getAttribute('data-scrolled') === 'true') {
        morphInProgress = true;
      }
    });
    morphObserver.observe(header, {
      attributes: true,
      attributeFilter: ['data-nav-expanded'],
    });

    nav.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'width') return;
      morphInProgress = false;
      var target = pendingHoverItem || nav.querySelector('[data-nav-item]:hover');
      pendingHoverItem = null;
      if (target) {
        targetPill(target);
        setHighlight(target);
      }
    });
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      // Set highlight immediately so color-state CSS (logo swap, text inversion)
      // tracks the right item even if pill movement is deferred for the morph.
      setHighlight(item);
      targetPillWhenSettled(item);
    });
    item.addEventListener('focus', function () {
      setHighlight(item);
      targetPillWhenSettled(item);
    });
  });

  // On mouseleave / focusout: rest at active if present (slide back); otherwise
  // hide the pill so the next hover spawns from rest instead of flying across.
  nav.addEventListener('mouseleave', function () {
    if (activeItem) {
      movePillTo(activeItem);
      setHighlight(activeItem);
    } else {
      movePillTo(null);
      setHighlight(null);
    }
  });

  nav.addEventListener('focusout', function (e) {
    if (!nav.contains(e.relatedTarget)) {
      if (activeItem) {
        movePillTo(activeItem);
        setHighlight(activeItem);
      } else {
        movePillTo(null);
        setHighlight(null);
      }
    }
  });

  // Reveal pill on the active item from the start (also in scroll state — CSS
  // hides it during the collapsed state, but the rest position is already
  // correct so the pill appears at the active item the moment the menu expands).
  if (activeItem) revealPillAt(activeItem);

  // When user scrolls back to the top from a state where they had hovered a
  // different item (so highlight + pill drifted), re-anchor to active.
  if (header) {
    var scrollObserver = new MutationObserver(function () {
      if (header.getAttribute('data-scrolled') !== 'true' && activeItem) {
        movePillTo(activeItem);
        setHighlight(activeItem);
      }
    });
    scrollObserver.observe(header, {
      attributes: true,
      attributeFilter: ['data-scrolled'],
    });
  }

  // Web fonts swap in async; text widths change and the initial rect goes stale.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      if (suppressJump()) return;
      var target = currentTarget();
      if (target) jumpPillTo(target);
    });
  }

  // The logo <img> has no fixed dimensions; once it decodes, items shift right.
  Array.from(nav.querySelectorAll('img')).forEach(function (img) {
    if (img.complete) return;
    img.addEventListener(
      'load',
      function () {
        if (suppressJump()) return;
        var target = currentTarget();
        if (target) jumpPillTo(target);
      },
      { once: true }
    );
  });

  // Catch-all for any other late layout shift inside the nav.
  if (typeof ResizeObserver !== 'undefined') {
    var observerReady = false;
    var ro = new ResizeObserver(function () {
      if (!observerReady) return;
      if (suppressJump()) return;
      var target = currentTarget();
      if (target) jumpPillTo(target);
    });
    items.forEach(function (item) {
      ro.observe(item);
    });
    // Skip the synchronous initial fire so it doesn't cancel the reveal fade.
    requestAnimationFrame(function () {
      observerReady = true;
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var current = currentTarget();
      if (current) {
        jumpPillTo(current);
      }
    }, 150);
  });
})();
